/**
 * Blog card component for article previews
 * Displays blog post thumbnail, title, date, and excerpt with lazy loading
 */

import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { getLowQualityPlaceholder, generateSrcSet } from 'libs/searchspring/components/ResultImage'

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function BlogCard({ blog }) {
  const articleImage = blog.image_alt || blog.image

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [articleImage?.src])

  return (
    <a
      href={blog.url}
      className="group/blog-card flex flex-col gap-y-1 md:gap-y-1.5"
      aria-label={`Read more about ${blog.title}`}
    >
      <div className="overflow-hidden aspect-1/1 w-full bg-neutral-medium children:size-full children:object-cover children:transition-all children:group-hover/blog-card:scale-[1.025]">
        {articleImage?.src && (
          <img
            className="lazy size-full object-cover transition-all group-hover/blog-card:scale-[1.025]"
            src={getLowQualityPlaceholder(articleImage.src)}
            data-src={articleImage.src}
            data-srcset={generateSrcSet(articleImage.src, IMAGE_WIDTHS)}
            data-sizes="50vw"
            alt={articleImage.alt || blog.title}
            width={articleImage.width}
            height={articleImage.height}
          />
        )}
      </div>

      <div className="flex flex-col gap-y-0.75 pr-1 lg:pr-1.5">
        <h3 className="h5">{blog.title}</h3>
        {blog.excerpt && <div className="richtext paragraph-b w-fit">{blog.excerpt}</div>}
        <div className="w-fit btn btn-text btn-primary btn-s group-hover/blog-card:opacity-50">Read More</div>
      </div>
    </a>
  )
}
